import { ReactComponent as billboardSmallSingle } from "../../../../img/billboard-small-single.svg";
import { ReactComponent as billboardSmallMore } from "../../../../img/billboard-small-more.svg";
import { ReactComponent as billboardBigSingle } from "../../../../img/billboard-big-single.svg";
import { ReactComponent as billboardBigMore } from "../../../../img/billboard-big-more.svg";
import { ReactComponent as PosterSingleHigh } from "../../../../img/poster-one-high.svg";
import { ReactComponent as PosterMoreHigh } from "../../../../img/poster-more-high.svg";
import { ReactComponent as PosterSingleWide } from "../../../../img/poster-one-wide.svg";
import { ReactComponent as PlaqueColorSingleHigh } from "../../../../img/plaque-one-green-high.svg";
import { ReactComponent as PlaqueSingleHigh } from "../../../../img/plaque-one-black-high.svg";
import { ReactComponent as PlaqueColorMoreHigh } from "../../../../img/plaque-more-green-high.svg";
import { ReactComponent as PlaqueMoreHigh } from "../../../../img/plaque-more-black-high.svg";
import { ReactComponent as PlaqueColorSingleWide } from "../../../../img/plaque-one-green-wide.svg";
import { ReactComponent as PlaqueSingleWide } from "../../../../img/plaque-one-black-wide.svg";
import { FormatTypeImageOrientation } from "./forms/format-form/format-form-enums";
import { DateFormatType } from "./generator-enum";
export var getPrograms = function () { return [
    {
        value: "npzpzs",
        name: "Národní program Životní prostředí",
        note: "Zastřešující schéma",
        fullSponsored: false,
        formatGroups: [
            {
                formats: [
                    {
                        name: "Billboard",
                        size: "2100 x 2200 mm",
                        showSize: true,
                        width: 2100,
                        height: 2200,
                        pdfPreviewClass: "billboard-small",
                        tooltipKey: "billboard-small",
                        dateFormat: DateFormatType.Date,
                        formatTypes: [
                            {
                                value: "billboard_small_single",
                                name: "Jeden projekt",
                                nameLimit: 150,
                                goalLimit: 500,
                                showLogo: true,
                                debetFields: false,
                                ImageComponent: billboardSmallSingle,
                                imageOrientation: FormatTypeImageOrientation.Portrait,
                                maxProjectCount: 1,
                            },
                            {
                                value: "billboard_small_more",
                                name: "Více projektů",
                                nameLimit: 150,
                                goalLimit: 500,
                                showLogo: true,
                                debetFields: false,
                                ImageComponent: billboardSmallMore,
                                imageOrientation: FormatTypeImageOrientation.Portrait,
                                maxProjectCount: 3,
                            },
                        ],
                    },
                    {
                        name: "Billboard",
                        size: "5100 x 2400 mm",
                        showSize: true,
                        width: 5100,
                        height: 2400,
                        pdfPreviewClass: "billboard-big",
                        tooltipKey: "billboard-big",
                        dateFormat: DateFormatType.Date,
                        formatTypes: [
                            {
                                value: "billboard_big_single",
                                name: "Jeden projekt",
                                nameLimit: 150,
                                goalLimit: 500,
                                showLogo: true,
                                debetFields: false,
                                ImageComponent: billboardBigSingle,
                                imageOrientation: FormatTypeImageOrientation.Landscape,
                                maxProjectCount: 1,
                            },
                            {
                                value: "billboard_big_more",
                                name: "Více projektů",
                                nameLimit: 150,
                                goalLimit: 500,
                                showLogo: true,
                                debetFields: false,
                                ImageComponent: billboardBigMore,
                                imageOrientation: FormatTypeImageOrientation.Landscape,
                                maxProjectCount: 3,
                            },
                        ],
                    },
                ],
            },
            {
                formats: [
                    {
                        name: "Plakát A3",
                        size: "297 x 420 mm",
                        showSize: false,
                        width: 297,
                        height: 420,
                        pdfPreviewClass: "poster-a3",
                        tooltipKey: "poster-a3",
                        dateFormat: DateFormatType.Date,
                        formatTypes: [
                            {
                                value: "poster_single",
                                name: "Jeden projekt",
                                nameLimit: 160,
                                goalLimit: 520,
                                showLogo: true,
                                debetFields: false,
                                ImageComponent: PosterSingleHigh,
                                imageOrientation: FormatTypeImageOrientation.Portrait,
                                maxProjectCount: 1,
                            },
                            {
                                value: "poster_more",
                                name: "Více projektů",
                                nameLimit: 160,
                                goalLimit: 520,
                                showLogo: true,
                                debetFields: false,
                                ImageComponent: PosterMoreHigh,
                                imageOrientation: FormatTypeImageOrientation.Portrait,
                                maxProjectCount: 3,
                            },
                        ],
                    },
                    {
                        name: "Elektronický plakát",
                        size: "1920 x 1080 px",
                        showSize: false,
                        width: 1920,
                        height: 1080,
                        pdfPreviewClass: "poster-electric",
                        tooltipKey: "poster-electronic",
                        dateFormat: DateFormatType.Date,
                        formatTypes: [
                            {
                                value: "poster_electronic_single",
                                name: "Jeden projekt",
                                nameLimit: 170,
                                goalLimit: 520,
                                showLogo: true,
                                debetFields: false,
                                ImageComponent: PosterSingleWide,
                                imageOrientation: FormatTypeImageOrientation.Landscape,
                                maxProjectCount: 1,
                            },
                        ],
                    },
                ],
            },
            {
                formats: [
                    {
                        name: "Pamětní deska",
                        size: "300 x 400 mm",
                        pdfPreviewClass: "plaque-portrait",
                        tooltipKey: "plaque",
                        dateFormat: DateFormatType.Year,
                        formatTypes: [
                            {
                                value: "plaque_color_single",
                                name: "Barevná varianta - jeden projekt",
                                nameLimit: 170,
                                goalLimit: 520,
                                ImageComponent: PlaqueColorSingleHigh,
                                imageOrientation: FormatTypeImageOrientation.Portrait,
                                maxProjectCount: 1,
                            },
                            {
                                value: "plaque_black_single",
                                name: "Černobílá varianta - jeden projekt",
                                nameLimit: 170,
                                goalLimit: 520,
                                ImageComponent: PlaqueSingleHigh,
                                imageOrientation: FormatTypeImageOrientation.Portrait,
                                maxProjectCount: 1,
                            },
                            {
                                value: "plaque_color_more",
                                name: "Barevná varianta - více projektů",
                                nameLimit: 170,
                                goalLimit: 300,
                                ImageComponent: PlaqueColorMoreHigh,
                                imageOrientation: FormatTypeImageOrientation.Portrait,
                                maxProjectCount: 3,
                            },
                            {
                                value: "plaque_black_more",
                                name: "Černobílá varianta - více projektů",
                                nameLimit: 170,
                                goalLimit: 300,
                                ImageComponent: PlaqueMoreHigh,
                                imageOrientation: FormatTypeImageOrientation.Portrait,
                                maxProjectCount: 3,
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        value: "npzpnpo",
        name: "Národní program Životní prostředí",
        note: "Národní plán obnovy",
        fullSponsored: false,
        formatGroups: [
            {
                formats: [
                    {
                        name: "Billboard",
                        size: "2100 x 2200 mm",
                        showSize: true,
                        width: 2100,
                        height: 2200,
                        pdfPreviewClass: "billboard-small",
                        tooltipKey: "billboard-small",
                        dateFormat: DateFormatType.Date,
                        formatTypes: [
                            {
                                value: "billboard_small_single",
                                name: "Jeden projekt",
                                nameLimit: 170,
                                goalLimit: 350,
                                ImageComponent: billboardSmallSingle,
                                imageOrientation: FormatTypeImageOrientation.Portrait,
                                maxProjectCount: 1,
                            },
                        ],
                    },
                    {
                        name: "Billboard",
                        size: "5100 x 2400 mm",
                        showSize: true,
                        width: 5100,
                        height: 2400,
                        pdfPreviewClass: "billboard-big",
                        tooltipKey: "billboard-big",
                        dateFormat: DateFormatType.Date,
                        formatTypes: [
                            {
                                value: "billboard_big_single",
                                name: "Jeden projekt",
                                nameLimit: 170,
                                goalLimit: 350,
                                ImageComponent: billboardBigSingle,
                                imageOrientation: FormatTypeImageOrientation.Landscape,
                                maxProjectCount: 1,
                            },
                        ],
                    },
                ],
            },
            {
                formats: [
                    {
                        name: "Plakát A3",
                        size: "297 x 420 mm",
                        showSize: false,
                        width: 297,
                        height: 420,
                        pdfPreviewClass: "poster-a3",
                        tooltipKey: "poster-a3",
                        dateFormat: DateFormatType.Date,
                        formatTypes: [
                            {
                                value: "poster_single",
                                name: "Jeden projekt",
                                nameLimit: 170,
                                goalLimit: 350,
                                ImageComponent: PosterSingleHigh,
                                imageOrientation: FormatTypeImageOrientation.Portrait,
                                maxProjectCount: 1,
                            },
                        ],
                    },
                    {
                        name: "Elektronický plakát",
                        size: "1920 x 1080 px",
                        showSize: false,
                        width: 1920,
                        height: 1080,
                        pdfPreviewClass: "poster-electric",
                        tooltipKey: "poster-electronic",
                        dateFormat: DateFormatType.Date,
                        formatTypes: [
                            {
                                value: "poster_electronic_single",
                                name: "Jeden projekt",
                                nameLimit: 170,
                                goalLimit: 350,
                                ImageComponent: PosterSingleWide,
                                imageOrientation: FormatTypeImageOrientation.Landscape,
                                maxProjectCount: 1,
                            },
                        ],
                    },
                ],
            },
            {
                formats: [
                    {
                        name: "Pamětní deska",
                        size: "400 x 300 mm",
                        pdfPreviewClass: "plaque-landscape",
                        tooltipKey: "plaque",
                        dateFormat: DateFormatType.Year,
                        formatTypes: [
                            {
                                value: "plaque_color_single",
                                name: "Barevná varianta - jeden projekt",
                                nameLimit: 170,
                                goalLimit: 350,
                                ImageComponent: PlaqueColorSingleWide,
                                imageOrientation: FormatTypeImageOrientation.Landscape,
                                maxProjectCount: 1,
                            },
                            {
                                value: "plaque_black_single",
                                name: "Černobílá varianta - jeden projekt",
                                nameLimit: 170,
                                goalLimit: 350,
                                ImageComponent: PlaqueSingleWide,
                                imageOrientation: FormatTypeImageOrientation.Landscape,
                                maxProjectCount: 1,
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        value: "npzp",
        name: "Národní program Životní prostředí",
        fullSponsored: false,
        formatGroups: [
            {
                formats: [
                    {
                        name: "Billboard",
                        size: "2000 x 1000 mm",
                        showSize: true,
                        width: 2000,
                        height: 1000,
                        dateFormat: DateFormatType.Date,
                        pdfPreviewClass: "billboard-old",
                        tooltipKey: "billboard-old",
                        formatTypes: [
                            {
                                value: "billboard_old_single",
                                name: "Jeden projekt",
                                nameLimit: 170,
                                goalLimit: 350,
                                ImageComponent: billboardBigSingle,
                                imageOrientation: FormatTypeImageOrientation.Landscape,
                                maxProjectCount: 1,
                            },
                        ],
                    },
                ],
            },
            {
                formats: [
                    {
                        name: "Plakát A3",
                        size: "297 x 420 mm",
                        showSize: false,
                        width: 297,
                        height: 420,
                        pdfPreviewClass: "poster-a3",
                        tooltipKey: "poster-a3",
                        dateFormat: DateFormatType.Date,
                        formatTypes: [
                            {
                                value: "poster_single",
                                name: "Jeden projekt",
                                nameLimit: 170,
                                goalLimit: 350,
                                ImageComponent: PosterSingleHigh,
                                imageOrientation: FormatTypeImageOrientation.Portrait,
                                maxProjectCount: 1,
                            },
                        ],
                    },
                    {
                        name: "Elektronický plakát",
                        size: "1920 x 1080 px",
                        showSize: false,
                        width: 1920,
                        height: 1080,
                        pdfPreviewClass: "poster-electric",
                        tooltipKey: "poster-electronic",
                        dateFormat: DateFormatType.Date,
                        formatTypes: [
                            {
                                value: "poster_electronic_single",
                                name: "Jeden projekt",
                                nameLimit: 170,
                                goalLimit: 350,
                                ImageComponent: PosterSingleWide,
                                imageOrientation: FormatTypeImageOrientation.Landscape,
                                maxProjectCount: 1,
                            },
                        ],
                    },
                ],
            },
            {
                formats: [
                    {
                        name: "Pamětní deska",
                        size: "400 x 300 mm",
                        pdfPreviewClass: "plaque-landscape",
                        tooltipKey: "plaque",
                        dateFormat: DateFormatType.Year,
                        formatTypes: [
                            {
                                value: "plaque_color_single",
                                name: "Barevná varianta - jeden projekt",
                                nameLimit: 170,
                                goalLimit: 350,
                                ImageComponent: PlaqueColorSingleWide,
                                imageOrientation: FormatTypeImageOrientation.Landscape,
                                maxProjectCount: 1,
                            },
                            {
                                value: "plaque_black_single",
                                name: "Černobílá varianta - jeden projekt",
                                nameLimit: 170,
                                goalLimit: 350,
                                ImageComponent: PlaqueSingleWide,
                                imageOrientation: FormatTypeImageOrientation.Landscape,
                                maxProjectCount: 1,
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        value: "mf",
        name: "Modernizační fond",
        separator: ' ',
        note: "2021–2030",
        fullSponsored: false,
        formatGroups: [
            {
                formats: [
                    {
                        name: "Billboard",
                        size: "2000 x 1000 mm",
                        showSize: true,
                        width: 2000,
                        height: 1000,
                        pdfPreviewClass: "billboard-small",
                        tooltipKey: "billboard-small",
                        dateFormat: DateFormatType.Date,
                        formatTypes: [
                            {
                                value: "billboard_small_single",
                                name: "",
                                nameLimit: 120,
                                goalLimit: 320,
                                showLogo: false,
                                debetFields: true,
                                programSupport: true,
                                ImageComponent: billboardBigSingle,
                                imageOrientation: FormatTypeImageOrientation.Landscape,
                                maxProjectCount: 1,
                            },
                        ],
                    },
                ],
            },
            {
                formats: [
                    {
                        name: "Plakát A3",
                        size: "297 x 420 mm",
                        showSize: false,
                        width: 297,
                        height: 420,
                        pdfPreviewClass: "poster-a3",
                        tooltipKey: "poster-a3",
                        dateFormat: DateFormatType.Date,
                        formatTypes: [
                            {
                                value: "poster_single",
                                name: "",
                                nameLimit: 80,
                                goalLimit: 230,
                                showLogo: false,
                                debetFields: true,
                                programSupport: true,
                                ImageComponent: PosterSingleHigh,
                                imageOrientation: FormatTypeImageOrientation.Portrait,
                                maxProjectCount: 1,
                            },
                        ],
                    },
                    {
                        name: "Elektronický plakát",
                        size: "1920 x 1080 px",
                        showSize: false,
                        width: 1920,
                        height: 1080,
                        pdfPreviewClass: "poster-electric",
                        tooltipKey: "poster-electronic",
                        dateFormat: DateFormatType.Date,
                        formatTypes: [
                            {
                                value: "poster_electronic_single",
                                name: "",
                                nameLimit: 80,
                                goalLimit: 230,
                                showLogo: false,
                                debetFields: true,
                                programSupport: true,
                                ImageComponent: PosterSingleWide,
                                imageOrientation: FormatTypeImageOrientation.Landscape,
                                maxProjectCount: 1,
                            },
                        ],
                    },
                ],
            },
            {
                formats: [
                    {
                        name: "Pamětní deska",
                        size: "400 x 300 mm",
                        pdfPreviewClass: "plaque-portrait",
                        tooltipKey: "plaque",
                        dateFormat: DateFormatType.Year,
                        formatTypes: [
                            {
                                value: "plaque_color_single",
                                nameLimit: 80,
                                debetFields: true,
                                name: "Barevná varianta",
                                ImageComponent: PlaqueColorSingleHigh,
                                imageOrientation: FormatTypeImageOrientation.Landscape,
                                maxProjectCount: 1,
                            },
                            {
                                value: "plaque_black_single",
                                nameLimit: 80,
                                debetFields: true,
                                name: "Černobílá varianta",
                                ImageComponent: PlaqueSingleHigh,
                                imageOrientation: FormatTypeImageOrientation.Landscape,
                                maxProjectCount: 1,
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        value: "opst",
        name: "Operační program Spravedlivá transformace",
        separator: ' ',
        note: "2021–2027",
        fullSponsored: true,
        formatGroups: [
            {
                formats: [
                    {
                        name: "Billboard",
                        size: "2100 x 2200 mm",
                        showSize: true,
                        width: 2100,
                        height: 2200,
                        pdfPreviewClass: "billboard-small",
                        tooltipKey: "billboard-small",
                        dateFormat: DateFormatType.Date,
                        formatTypes: [
                            {
                                value: "billboard_small_single",
                                name: "Jeden projekt",
                                nameLimit: 150,
                                goalLimit: 500,
                                showLogo: true,
                                debetFields: false,
                                ImageComponent: billboardSmallSingle,
                                imageOrientation: FormatTypeImageOrientation.Portrait,
                                maxProjectCount: 1,
                            },
                            {
                                value: "billboard_small_more",
                                name: "Více projektů",
                                nameLimit: 150,
                                goalLimit: 500,
                                showLogo: true,
                                debetFields: false,
                                ImageComponent: billboardSmallMore,
                                imageOrientation: FormatTypeImageOrientation.Portrait,
                                maxProjectCount: 3,
                            },
                        ],
                    },
                    {
                        name: "Billboard",
                        size: "5100 x 2400 mm",
                        showSize: true,
                        width: 5100,
                        height: 2400,
                        pdfPreviewClass: "billboard-big",
                        tooltipKey: "billboard-big",
                        dateFormat: DateFormatType.Date,
                        formatTypes: [
                            {
                                value: "billboard_big_single",
                                name: "Jeden projekt",
                                nameLimit: 150,
                                goalLimit: 500,
                                showLogo: true,
                                debetFields: false,
                                ImageComponent: billboardBigSingle,
                                imageOrientation: FormatTypeImageOrientation.Landscape,
                                maxProjectCount: 1,
                            },
                            {
                                value: "billboard_big_more",
                                name: "Více projektů",
                                nameLimit: 150,
                                goalLimit: 500,
                                showLogo: true,
                                debetFields: false,
                                ImageComponent: billboardBigMore,
                                imageOrientation: FormatTypeImageOrientation.Landscape,
                                maxProjectCount: 3,
                            },
                        ],
                    },
                ],
            },
            {
                formats: [
                    {
                        name: "Plakát A3",
                        size: "297 x 420 mm",
                        showSize: false,
                        width: 297,
                        height: 420,
                        pdfPreviewClass: "poster-a3",
                        tooltipKey: "poster-a3",
                        dateFormat: DateFormatType.Date,
                        formatTypes: [
                            {
                                value: "poster_single",
                                name: "Jeden projekt",
                                nameLimit: 160,
                                goalLimit: 520,
                                showLogo: true,
                                debetFields: false,
                                ImageComponent: PosterSingleHigh,
                                imageOrientation: FormatTypeImageOrientation.Portrait,
                                maxProjectCount: 1,
                            },
                            {
                                value: "poster_more",
                                name: "Více projektů",
                                nameLimit: 160,
                                goalLimit: 520,
                                showLogo: true,
                                debetFields: false,
                                ImageComponent: PosterMoreHigh,
                                imageOrientation: FormatTypeImageOrientation.Portrait,
                                maxProjectCount: 3,
                            },
                        ],
                    },
                    {
                        name: "Elektronický plakát",
                        size: "1920 x 1080 px",
                        showSize: false,
                        width: 1920,
                        height: 1080,
                        pdfPreviewClass: "poster-electric",
                        tooltipKey: "poster-electronic",
                        dateFormat: DateFormatType.Date,
                        formatTypes: [
                            {
                                value: "poster_electronic_single",
                                name: "Jeden projekt",
                                nameLimit: 170,
                                goalLimit: 520,
                                showLogo: true,
                                debetFields: false,
                                ImageComponent: PosterSingleWide,
                                imageOrientation: FormatTypeImageOrientation.Landscape,
                                maxProjectCount: 1,
                            },
                        ],
                    },
                ],
            },
            {
                formats: [
                    {
                        name: "Pamětní deska",
                        size: "300 x 400 mm",
                        pdfPreviewClass: "plaque-portrait",
                        tooltipKey: "plaque",
                        dateFormat: DateFormatType.Year,
                        formatTypes: [
                            {
                                value: "plaque_color_single",
                                nameLimit: 170,
                                goalLimit: 520,
                                name: "Barevná varianta - jeden projekt",
                                ImageComponent: PlaqueColorSingleHigh,
                                imageOrientation: FormatTypeImageOrientation.Portrait,
                                maxProjectCount: 1,
                            },
                            {
                                value: "plaque_black_single",
                                nameLimit: 170,
                                goalLimit: 520,
                                name: "Černobílá varianta - jeden projekt",
                                ImageComponent: PlaqueSingleHigh,
                                imageOrientation: FormatTypeImageOrientation.Portrait,
                                maxProjectCount: 1,
                            },
                            {
                                value: "plaque_color_more",
                                name: "Barevná varianta - více projektů",
                                nameLimit: 170,
                                goalLimit: 300,
                                ImageComponent: PlaqueColorMoreHigh,
                                imageOrientation: FormatTypeImageOrientation.Portrait,
                                maxProjectCount: 3,
                            },
                            {
                                value: "plaque_black_more",
                                name: "Černobílá varianta - více projektů",
                                nameLimit: 170,
                                goalLimit: 300,
                                ImageComponent: PlaqueMoreHigh,
                                imageOrientation: FormatTypeImageOrientation.Portrait,
                                maxProjectCount: 3,
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        value: "opzp",
        name: "Operační program Životní prostředí",
        separator: ' ',
        note: "2021–2027",
        fullSponsored: true,
        formatGroups: [
            {
                formats: [
                    {
                        name: "Billboard",
                        size: "2100 x 2200 mm",
                        showSize: true,
                        width: 2100,
                        height: 2200,
                        pdfPreviewClass: "billboard-small",
                        tooltipKey: "billboard-small",
                        dateFormat: DateFormatType.Date,
                        formatTypes: [
                            {
                                value: "billboard_small_single",
                                name: "Jeden projekt",
                                nameLimit: 150,
                                goalLimit: 500,
                                showLogo: true,
                                debetFields: false,
                                ImageComponent: billboardSmallSingle,
                                imageOrientation: FormatTypeImageOrientation.Portrait,
                                maxProjectCount: 1,
                            },
                            {
                                value: "billboard_small_more",
                                name: "Více projektů",
                                nameLimit: 150,
                                goalLimit: 500,
                                showLogo: true,
                                debetFields: false,
                                ImageComponent: billboardSmallMore,
                                imageOrientation: FormatTypeImageOrientation.Portrait,
                                maxProjectCount: 3,
                            },
                        ],
                    },
                    {
                        name: "Billboard",
                        size: "5100 x 2400 mm",
                        showSize: true,
                        width: 5100,
                        height: 2400,
                        pdfPreviewClass: "billboard-big",
                        tooltipKey: "billboard-big",
                        dateFormat: DateFormatType.Date,
                        formatTypes: [
                            {
                                value: "billboard_big_single",
                                name: "Jeden projekt",
                                nameLimit: 150,
                                goalLimit: 500,
                                showLogo: true,
                                debetFields: false,
                                ImageComponent: billboardBigSingle,
                                imageOrientation: FormatTypeImageOrientation.Landscape,
                                maxProjectCount: 1,
                            },
                            {
                                value: "billboard_big_more",
                                name: "Více projektů",
                                nameLimit: 150,
                                goalLimit: 500,
                                showLogo: true,
                                debetFields: false,
                                ImageComponent: billboardBigMore,
                                imageOrientation: FormatTypeImageOrientation.Landscape,
                                maxProjectCount: 3,
                            },
                        ],
                    },
                ],
            },
            {
                formats: [
                    {
                        name: "Plakát A3",
                        size: "297 x 420 mm",
                        showSize: false,
                        width: 297,
                        height: 420,
                        pdfPreviewClass: "poster-a3",
                        tooltipKey: "poster-a3",
                        dateFormat: DateFormatType.Date,
                        formatTypes: [
                            {
                                value: "poster_single",
                                name: "Jeden projekt",
                                nameLimit: 160,
                                goalLimit: 520,
                                showLogo: true,
                                debetFields: false,
                                ImageComponent: PosterSingleHigh,
                                imageOrientation: FormatTypeImageOrientation.Portrait,
                                maxProjectCount: 1,
                            },
                            {
                                value: "poster_more",
                                name: "Více projektů",
                                nameLimit: 160,
                                goalLimit: 520,
                                showLogo: true,
                                debetFields: false,
                                ImageComponent: PosterMoreHigh,
                                imageOrientation: FormatTypeImageOrientation.Portrait,
                                maxProjectCount: 3,
                            },
                        ],
                    },
                    {
                        name: "Elektronický plakát",
                        size: "1920 x 1080 px",
                        showSize: false,
                        width: 1920,
                        height: 1080,
                        pdfPreviewClass: "poster-electric",
                        tooltipKey: "poster-electronic",
                        dateFormat: DateFormatType.Date,
                        formatTypes: [
                            {
                                value: "poster_electronic_single",
                                name: "Jeden projekt",
                                nameLimit: 170,
                                goalLimit: 520,
                                showLogo: true,
                                debetFields: false,
                                ImageComponent: PosterSingleWide,
                                imageOrientation: FormatTypeImageOrientation.Landscape,
                                maxProjectCount: 1,
                            },
                        ],
                    },
                ],
            },
            {
                formats: [
                    {
                        name: "Pamětní deska",
                        size: "300 x 400 mm",
                        pdfPreviewClass: "plaque-portrait",
                        tooltipKey: "plaque",
                        dateFormat: DateFormatType.Year,
                        formatTypes: [
                            {
                                value: "plaque_color_single",
                                nameLimit: 170,
                                goalLimit: 520,
                                name: "Barevná varianta - jeden projekt",
                                ImageComponent: PlaqueColorSingleHigh,
                                imageOrientation: FormatTypeImageOrientation.Portrait,
                                maxProjectCount: 1,
                            },
                            {
                                value: "plaque_black_single",
                                nameLimit: 170,
                                goalLimit: 520,
                                name: "Černobílá varianta - jeden projekt",
                                ImageComponent: PlaqueSingleHigh,
                                imageOrientation: FormatTypeImageOrientation.Portrait,
                                maxProjectCount: 1,
                            },
                            {
                                value: "plaque_color_more",
                                name: "Barevná varianta - více projektů",
                                nameLimit: 170,
                                goalLimit: 300,
                                ImageComponent: PlaqueColorMoreHigh,
                                imageOrientation: FormatTypeImageOrientation.Portrait,
                                maxProjectCount: 3,
                            },
                            {
                                value: "plaque_black_more",
                                name: "Černobílá varianta - více projektů",
                                nameLimit: 170,
                                goalLimit: 300,
                                ImageComponent: PlaqueMoreHigh,
                                imageOrientation: FormatTypeImageOrientation.Portrait,
                                maxProjectCount: 3,
                            },
                        ],
                    },
                ],
            },
        ],
    },
]; };
